<template>
  <component
    :field="referencedField"
    :is="'checkout-field-' + referencedField.type"
  >
  </component>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-reference",
  computed: {
    referencedField: function() {
      return this.field.reference.reduce(
        (obj, key) => obj.fields.find(field => field.name === key),
        this.$store.state
      );
    }
  }
};
</script>
